import { render, staticRenderFns } from "./ParamOcorrenciaDetalhes.vue?vue&type=template&id=32041ffe"
import script from "./ParamOcorrenciaDetalhes.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports